import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useField } from '@unform/core';
import { InputLabel, Checkbox } from '@material-ui/core';

interface CheckProps {
  name: string;
  label: string;
  valor: string[];
  valueDefault: boolean;
}
const CheckBox: React.FC<CheckProps> = ({
  name,
  label,
  valor,
  valueDefault,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [checked, setChecked] = React.useState(valor[0]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value == valor[0]) {
      setChecked(valor[1]);
    } else {
      setChecked(valor[0]);
    }
  };
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox
        {...rest}
        defaultChecked={valueDefault}
        onChange={handleChange}
        value={checked}
        color="primary"
        inputRef={inputRef}
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
      <InputLabel
        id="select-label"
        style={{ marginBottom: '4px', marginLeft: '2px' }}
      >
        {label}
      </InputLabel>
    </div>
  );
};

export default CheckBox;
